import React, { useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { OrderListUpdate } from "../../../API/routine";
import { toast } from "react-toastify";
import {
  TableDeleteBtn,
  TableEditBtn,
  TableViewBtn,
} from "../../../images/Svgs";
import { CustomToolTip, formatAMPM } from "../../../utils/common";
import {
  applyFilterSort,
  isFilterActive,
  getStudioName,
  getSessionLabel,
  getEntry,
  EMPTY_FILTERS,
} from "../EventFilters/eventFilterUtils";

const EventDetailList = ({
  handleEditRoutine,
  routingList,
  handleDeleteRoutine,
  handleDetailRoutine,
  handleLogisticsChange,
  eventId,
  fetchRoutine,
  // ---------- NEW (sab optional, purani call sites break nahi hongi) ----------
  filters = EMPTY_FILTERS,
  showStudioSessionColumns = true,
  onCountsChange, // (matchedCount, totalCount) => void
}) => {
  const [rows, setRows] = useState([]);
  const [matchedIds, setMatchedIds] = useState(new Set());
  const [activeRowId, setActiveRowId] = useState(null);
  const IsAccess = JSON.parse(localStorage.getItem("userDetail"));
  const [matchedCount, setMatchedCount] = useState(0);

  const scrollRef = useRef(null);
  // filtersActive = isFilterActive(filters);

  // entry search alag se: kya searched entry kisi bhi row me exist karti hai?
  const entryTerm = (filters?.entry || "").trim();
  // const entryNotFound =
  //   entryTerm !== "" &&
  //   !(routingList || []).some((row) => {
  //     const e = getEntry(row);
  //     return e === entryTerm || e.startsWith(`${entryTerm}.`);
  //   });

  //   const noFilterMatch = filtersActive && matchedCount === 0;  

  const filtersActive = isFilterActive(filters);

  const completed = (routingList || [])
    .filter((item) => item.completed === 1)
    .sort((a, b) => a.id - b.id);

  const notCompleted = (routingList || []).filter(
    (item) => item.completed === 0
  );

  const finalData = [...completed, ...notCompleted];

  const {
    rows: filteredPreviewRows,
    matchedCount: currentMatchedCount,
  } = applyFilterSort(finalData, filters);

  const noFilterMatch = filtersActive && currentMatchedCount === 0;

  useEffect(() => {
    if (!routingList) return;

    const completed = routingList
      .filter((item) => item.completed === 1)
      .sort((a, b) => a.id - b.id); // DESC

    const notCompleted = routingList.filter((item) => item.completed === 0);
    // agar completed upar chahiye
    const finalData = [...completed, ...notCompleted];

    // 👇 filter/search lagne par matched rows top par, baaki as-it-is neeche
    const {
      rows: ordered,
      matchedCount,
      matchedIds: ids,
    } = applyFilterSort(finalData, filters);

    setRows(ordered);
    setMatchedIds(ids);
    // setMatchedCount(matchedCount);

    if (typeof onCountsChange === "function") {

      // sirf wo rows ginni hai jinki entry # hai (openDoor/message rows chhod do)
      const entryRowCount = finalData.filter((r) => getEntry(r) !== "").length;
      onCountsChange(matchedCount, entryRowCount);
      // onCountsChange(matchedCount, finalData.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routingList, filters]);

  // filter/search badalte hi list ko upar le aao — matches wahin pin hain
  useEffect(() => {
    if (!filtersActive || !scrollRef.current) return;
    scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
  }, [filters, filtersActive]);

  const onDragEnd = async (result) => {
    if (!result.destination) return;
    const reordered = [...rows];
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);

    const updatedArray = reordered.map((row, i) => ({
      id: row.id,
      index: i,
    }));

    const previousID = rows[result.source.index]?.id;
    const newID = rows[result.destination.index]?.id;

    setRows(reordered);
    await onChange(updatedArray, previousID, newID);
  };

  const onChange = async (data, previousID, newID) => {
    const payload = {
      event_id: eventId,
      previous_id: previousID,
      new_id: newID,
      order_list_update: data,
    };

    try {
      const response = await OrderListUpdate(payload);
      if (response?.status) {
        fetchRoutine();
        toast.success(response.message || "Success!");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during API request:", error);
    }
  };

  const handleAccessChange = async (userId, changes) => {
    const payload = {
      id: userId,
      completed:
        changes?.props !== undefined
          ? 0
          : changes?.completed !== ""
          ? changes?.completed === true
            ? 1
            : 0
          : 0,
    };

    // Only include 'starts' if it has a valid value
    if (typeof changes?.starts !== "undefined") {
      payload.starts = changes.starts;
    }

    if (changes?.props !== undefined) payload.props = changes.props;
    if (changes?.previousId) payload.previous_id = changes.previousId;

    await handleLogisticsChange(payload);

    if (changes.starts === 1) {
      setActiveRowId(userId);
    } else if (changes.starts === 2 || changes.completed === true) {
      setActiveRowId(null);
    }
  };

  return (
    <div
      className=""
      ref={scrollRef}
      style={{ maxHeight: "calc(100vh - 284px)", overflowY: "auto" }}
    >
      {/* {entryNotFound ? (
        <p className="ef-drag-note ef-drag-note--warn">
          No routine found for entry #{entryTerm}. Showing the full schedule
          below — check the number or clear the search.
        </p>
      ) : (
        filtersActive && (
          <p className="ef-drag-note">
            Filters on: matching routines are pinned to the top. Clear the
            filters to reorder rows again.
          </p>
        )
      )} */}

      {noFilterMatch ? (
        <p className="ef-drag-note ef-drag-note--warn">
          No routine found matching the selected filters. Showing the full
          schedule below — change or clear the filters.
        </p>
      ) : (
        filtersActive && (
          <p className="ef-drag-note">
            Filters on: matching routines are pinned to the top. Clear the
            filters to reorder rows again.
          </p>
        )
      )}

      <table className="table">
        <thead className="text-center">
          <tr>
            <th>Time</th>
            <th>Props</th>
            <th>Entry #</th>
            <th>Entry Title</th>
            {/* {showStudioSessionColumns && <th>Studio</th>} */}
            {showStudioSessionColumns && <th>Session</th>}
            <th>Age</th>
            <th>Level</th>
            <th style={{ minWidth: "120px" }}>Entry Division</th>
            <th style={{ minWidth: "100px" }}>Performers</th>
            <th>Category</th>
            <th>Starts</th>
            <th>Actions</th>
            <th>Completed</th>
          </tr>
        </thead>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="routineTable">
            {(provided, snapshot) => (
              <tbody ref={provided.innerRef} {...provided.droppableProps}>
                {rows.map((row, index) => {
                  const isMatched = filtersActive && matchedIds.has(row.id);
                  const isDimmed = filtersActive && !isMatched;
                  const sessionLabel = getSessionLabel(row);

                  return (
                    <Draggable
                      key={row.id}
                      draggableId={row.id.toString()}
                      index={index}
                      isDragDisabled={row.completed === 1 || filtersActive}
                    >
                      {(provided) => (
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={`text-center ${
                            row.starts === 1 ||
                            row.starts === 2 ||
                            row.completed === 1
                              ? "start"
                              : "notstart"
                          } ${isMatched ? "ef-row--matched" : ""} ${
                            isDimmed ? "ef-row--dimmed" : ""
                          }`}
                          style={{
                            cursor: row.completed === 1 ? "not-allowed" : " ",
                            ...provided.draggableProps.style,
                            // position: snapshot.isDragging ? "absolute" : "static", // Fix position during drag
                            zIndex: snapshot.isDragging ? 999 : "auto", // Ensure it is above other rows
                            width: "100%", // Keep width of table consistent
                            left: snapshot.isDragging ? "0" : "auto", // Prevent misalignment
                            transition: "all 0.1s ease-out", // Smooth transition
                          }}
                        >
                          <td>{formatAMPM(row?.event_time_from)}</td>
                          <td>
                            {/* {row?.type === "routine" ? ( */}
                            {row?.type === "routine" ||
                            (row?.entry && row.entry.trim() !== "") ? (
                              <label className="container">
                                <input
                                  type="checkbox"
                                  checked={row?.props === 1}
                                  disabled={row?.completed === 1}
                                  onChange={(e) => {
                                    handleAccessChange(row.id, {
                                      props: e.target.checked ? 1 : 0,
                                      starts: row.starts ? row.starts : 0,
                                      completed: "",
                                    });
                                  }}
                                />
                                <span className="checkmark"></span>
                              </label>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{row?.entry || "-"}</td>
                          <td>{row?.entry_title || "-"}</td>
                          
                          {/* {showStudioSessionColumns && (
                            <td>{getStudioName(row) || "-"}</td>
                          )} */}

                          {showStudioSessionColumns && (
                            <td>
                              {sessionLabel ? (
                                <span className="ef-chip ef-chip--static">
                                  {sessionLabel}
                                </span>
                              ) : (
                                "-"
                              )}
                            </td>
                          )}
                          <td>{row?.masterAgeClass?.name || "-"}</td>
                          <td>{row?.masterLevel?.name || "-"}</td>
                          <td>{row?.masterEntryDivision?.name || "-"}</td>
                          <td>{row?.performers || "-"}</td>
                          <td>{row?.masterMusicCategory?.name || "-"}</td>
                          <td>
                            {row?.type === "routine" ||
                            ((row?.entry && row.entry.trim() !== "") &&
                              IsAccess?.is_access) ? (
                              // {row?.type === "routine" && IsAccess?.is_access ? (
                              <div className="checkbox-wrapper">
                                {/* ON Checkbox */}
                                <label
                                  htmlFor={`on-${row.id}`}
                                  className="checkbox-label check_box_btn"
                                >
                                  <input
                                    type="checkbox"
                                    id={`on-${row.id}`}
                                    checked={row.starts === 1}
                                    disabled={row.completed === 1}
                                    onChange={async () => {
                                      if (row.starts === 1) {
                                        await handleAccessChange(row.id, {
                                          starts: 0,
                                          completed: false,
                                        });
                                        setActiveRowId(null);
                                      } else {
                                        await handleAccessChange(row.id, {
                                          starts: 1,
                                          completed: false,
                                          previousId: activeRowId,
                                        });
                                        setActiveRowId(row.id);
                                      }
                                    }}
                                  />
                                  <p>On</p>
                                </label>

                                {/* OFF Checkbox */}
                                <label
                                  htmlFor={`off-${row.id}`}
                                  className="checkbox-label check_box_btn"
                                >
                                  <input
                                    type="checkbox"
                                    id={`off-${row.id}`}
                                    checked={row.starts === 2}
                                    disabled={row.completed === 1}
                                    onChange={async () => {
                                      if (row.starts === 2) {
                                        await handleAccessChange(row.id, {
                                          starts: 0,
                                          completed: false,
                                        });
                                        setActiveRowId(null);
                                      } else {
                                        await handleAccessChange(row.id, {
                                          starts: 2,
                                          completed: false,
                                        });
                                        setActiveRowId(null);
                                      }
                                    }}
                                  />
                                  <p>Off</p>
                                </label>
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <button
                              className="btn position-relative"
                              onClick={() => handleEditRoutine(row.id)}
                            >
                              <TableEditBtn />
                              <CustomToolTip type="edit" title="Routine" />
                            </button>
                            <button
                              className="btn position-relative"
                              onClick={() => handleDetailRoutine(row.id)}
                            >
                              <TableViewBtn />
                              <CustomToolTip type="view" title="Routine" />
                            </button>
                            <button
                              className="btn position-relative"
                              onClick={() => handleDeleteRoutine(row.id)}
                            >
                              <TableDeleteBtn />
                              <CustomToolTip type="delete" title="Routine" />
                            </button>
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={row.completed === 1}
                              onChange={(e) => {
                                handleAccessChange(row.id, {
                                  completed: e.target.checked,
                                  starts: row.starts ?? 0,
                                });
                              }}
                            />
                          </td>
                        </tr>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </tbody>
            )}
          </Droppable>
        </DragDropContext>
      </table>
    </div>
  );
};

export default EventDetailList;